import { builtInIntegrationCategory } from '@store/integration/built-in/built-in-integration-category';
import { builtInDestinationBuilderCategory } from '@store/integration/built-in/built-in-destination-builder-category';
import { builtInDestinationBuilderTemplate } from '@store/integration/built-in/built-in-destination-builder-template';

export default { builtInIntegrationCategory, builtInDestinationBuilderCategory, builtInDestinationBuilderTemplate };
